import { TripStatusReportDto } from '@/__generated';
import ReloadBtn from '@/components/app/ReloadBtn';
import ZTable, { IColumnType, ITableRef } from '@/components/ZTable';
import { dateTimeDisplayFormat } from '@/config';
import { TripStatusType } from '@/constants';
import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import { sortBy } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const getRecurrenceText = (recurrenceNumDays: number[]) => {
  if (recurrenceNumDays?.length === 7) {
    return 'Daily';
  }
  const days = sortBy(recurrenceNumDays || [], x => x);
  return days
    .map(d => moment().day(d))
    .map(x => x.format('dd'))
    .join(', ');
};
const columns: IColumnType<TripStatusReportDto>[] = [
  {
    title: 'Trip name',
    dataIndex: 'tripName',
  },
  {
    title: 'Bus No.',
    dataIndex: 'busNo',
  },
  {
    title: 'Departure time',
    dataIndex: 'departureDatetime',
    render: v => dateTimeDisplayFormat.originTimeOnly(v),
  },
  {
    title: 'tripDetailsPage_SourceStation',
    dataIndex: 'sourceStation',
  },
  {
    title: 'tripDetailsPage_DestinationStation',
    dataIndex: 'destinationStation',
  },
  {
    title: 'tripDetailsPage_Stops',
    dataIndex: 'noOfStops',
  },
  {
    title: 'base.Status',
    dataIndex: 'status',
    render: v => TripStatusType.__getValue(v),
  },
  {
    title: 'Recurrence',
    dataIndex: 'recurrenceNumDays',
    render: getRecurrenceText,
  },
];
const PAGE_TITLE = 'Trip Status';
export default function TripStatusReportPage() {
  const { t } = useTranslation();
  const departureZTb = React.useRef<ITableRef>();
  const arrivalZTb = React.useRef<ITableRef>();

  return (
    <MainContent
      title={t(PAGE_TITLE)}
      extraBtns={
        <ReloadBtn
          onClick={() => {
            departureZTb.current?.reload();
            arrivalZTb.current?.reload();
          }}
        />
      }
    >
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab="Departure trips" key="Departure">
            <ZTable
              columns={columns}
              primaryKey="id"
              tableRef={departureZTb}
              url="/trip-status-reports/get-reports/true"
              bordered
              order_by="departureDatetime"
              order_by_asc={true}
              allowEdit={false}
              allowDelete={false}
              transformDataSource={d => ({ data: d, total: 0 })}
              searchBtnAlignLeft
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Arrival trips" key="arrival">
            <ZTable
              columns={columns}
              primaryKey="id"
              tableRef={arrivalZTb}
              url="/trip-status-reports/get-reports/false"
              bordered
              order_by="departureDatetime"
              order_by_asc={true}
              allowEdit={false}
              allowDelete={false}
              searchBtnAlignLeft
              transformDataSource={d => ({ data: d, total: 0 })}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
